export default __webpack_public_path__ + "static/media/defending.84951685.md";